<ng-container *ngIf="actionSection">
	<div class="wrapper">

		<ul *ngIf="!navChange" class="list-reset has-padding is-stacked level divider nav-bar-zoom nav-bar-height">

			<ng-container *ngFor="let nav of navList">

				<ng-container *ngIf="nav.id == navId">
					<li routerLink={{nav.routerLink}} routerLinkActive="active"
						class="has-padding has-text-centered pointer" (click)="onClickNavigationLink(nav)"
						[tabIndex]="tabIndexOmit ? -1 : 0" matTooltip="{{nav.name}}" matTooltipPosition="below"
						matTooltipClass="bofa--heading is-7">

						<div class="bofa--heading is-3 zoom-button div-header">
							<img alt="Selected page {{ nav.name }}" src="assets/Complete_Icon.svg"
								class="intro-image bofa--heading is-3 icon-text zoom-img">
						</div>
						
						<p class="display-none">{{nav.name}}</p>
					</li>
				</ng-container>

				<ng-container *ngIf="nav.id > navId">
					<!-- this one can not have router pointer -->
					<li class="has-padding has-text-centered" matTooltip="{{nav.name}}" matTooltipPosition="below"
						matTooltipClass="bofa--heading is-7">

						<div tabindex="-1" class="dark-blue bofa--heading is-3 zoom-button div-header"><img
								tabindex="-1" alt="Navigate to {{ nav.name }} disabled" src="assets/Incomplete_icon.svg"
								class="intro-image bofa--heading is-3 icon-text zoom-img">
						</div>

						<p class="display-none">{{nav.name}}</p>
					</li>
				</ng-container>

				<ng-container *ngIf="lessThan(nav.id)">
					<li routerLink={{nav.routerLink}} routerLinkActive="active"
						class="has-padding has-text-centered pointer" (keyup.enter)="keyDown(nav)"
						(click)="onClickNavigationLink(nav)" (change)="onClickNavigationLink(nav)"
						[tabIndex]="tabIndexOmit ? -1 : 0" matTooltip="{{nav.name}}" matTooltipPosition="below"
						matTooltipClass="bofa--heading is-7 ">
						<div class="dark-blue bofa--heading is-3 zoom-button div-header"><img
								alt="Navigate to {{ nav.name }}" src="assets/Success_Icon.svg"
								class="intro-image bofa--heading is-3 icon-text zoom-img">
						</div>
						<p class="display-none">{{nav.name}}</p>
					</li>
				</ng-container>
			</ng-container>
		</ul>

		<nav *ngIf="navChange" mat-tab-nav-bar>

			<a mat-tab-link class="mat-tab-link-zoom opacity" *ngFor="let nav of navList"
				[disabled]="tabIndexOmit || nav.id > navId" (keyup.enter)="keyDown(nav)"
				(click)="onClickNavigationLink(nav)" (change)="onClickNavigationLink(nav)" matTooltip="{{nav.name}}"
				matTooltipClass="bofa--heading is-7" matTooltipPosition="below" routerLinkActive="active"
				[active]="nav.id == navId">

				<div *ngIf="nav.id == navId" class="bofa--heading is-3 zoom-button zoom-img div-header">

					<img alt="Selected page {{ nav.name }}" src="assets/Complete_Icon.svg"
						class="intro-image bofa--heading is-3 icon-text zoom-img">
					<p class="display-none">{{nav.name}}</p>
				</div>

				<div *ngIf="lessThan(nav.id)" class="has-padding has-text-centered pointer" tabindex="-1">
					<div tabindex="-1" class="dark-blue bofa--heading is-3 zoom-button zoom-img div-header"><img
							tabindex="-1" alt="Navigate to {{ nav.name }}" src="assets/Success_Icon.svg"
							class="intro-image bofa--heading is-3 icon-text zoom-img">
					</div>
					<p class="display-none">{{nav.name}}</p>
				</div>

				<div *ngIf="nav.id > navId" tabindex="-1" class="pointer-event" class="has-padding has-text-centered">
					<div tabindex="-1" class="dark-blue bofa--heading is-3 zoom-button zoom-img div-header"><img
							tabindex="-1" alt="{{ nav.name }}" src="assets/Incomplete_icon.svg"
							class="intro-image bofa--heading is-3 icon-text zoom-img">
					</div>
					<p class="display-none">{{nav.name}}</p>
				</div>
				<span *ngIf="mobile" class="mobile-nav">{{nav.name}}</span>
			</a>
		</nav>
		<mat-divider aria-hidden="true"></mat-divider>
	</div>
</ng-container>
